import { render, staticRenderFns } from "./EmConstrucao.vue?vue&type=template&id=2cab1a91&scoped=true"
import script from "./EmConstrucao.vue?vue&type=script&lang=js"
export * from "./EmConstrucao.vue?vue&type=script&lang=js"
import style0 from "./EmConstrucao.vue?vue&type=style&index=0&id=2cab1a91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cab1a91",
  null
  
)

export default component.exports